import { useState, useEffect, useContext } from "react";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import DataTable from "../ManageSettings/DataTables";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import { useNavigate } from "react-router-dom";
import AddExpenseTypeModal from "../ReusableForm/AddExpenseModal";
import AddVendorModal from "../ReusableForm/AddVendorModal";
import invoiceIcon from '../../../../assets/Image/invoiceIcon.png'
import expensetype from '../../../../assets/Image/expenses type .png'
import vendor from '../../../../assets/Image/vendor.png'
import CloseIcon from "../../../../assets/Image/close.png";
import { useToastHandler } from "../../../common/ToastHandler";
import { ToastContainer } from "react-toastify";
import useSwal from "../../../common/ReusableComponent/useSwal";
import useFormattingUtils from "../../../../context/useFormattingUtils";
import useMyPermissions from "../../../../utils/permissions/useMyPermissions";
import Can from "../../../../utils/permissions/Can";
import ChequeRenderer from "../Payroll/Cheque Layout/ChequeRenderer";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";


export default function Expense() {
  const { user } = useContext(AuthContext);
  const storeId = user.store;
  const { can } = useMyPermissions();


  const navigate = useNavigate();
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [, setShowAdditionalFields] = useState(false);
  const [showCheckFields, setShowCheckFields] = useState(false);
  const [showBankFields, setShowBankFields] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalVendor, setShowModalVendor] = useState(false);
  const [showModalExpense, setShowModalExpense] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [dueDays, setDueDays] = useState([]);
  const [bank, setBank] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const [selectedChequeLayout, setSelectedChequeLayout] = useState(null);
  const [, setInvoicesExpense] = useState([]);
  const [totalPaid, setTotalPaid] = useState(0.0);
  const [totalReceivedCredit, setTotalReceivedCredit] = useState(0.0);
  const [totalUnpaid, setTotalUnpaid] = useState(0.0);
  const [totalOutstandingCredit, setTotalOutstandingCredit] = useState(0.0);
  const [totalDue, setTotalDue] = useState(0.0);
  const [totalCredit, setTotalCredit] = useState(0.0);
  const [totalExpense, setTotalExpense] = useState(0.0);
  const { formatDate , currency} = useFormattingUtils();
  const [formData, setFormData] = useState({
    store: storeId,
    type: "expense",
    invoice_no: "",
    date: today,
    status: "",
    pay_method_status: "pay_now",
    pay_method: "cash",
    amount: "",
    pay_amount: "",
    discount: null,
    remaining_amount: null,
    after_discount: null,
    prepaid_tax: false,
    prepaid_tax_percentage: "",
    vendor_department: "",
    vendor_department_name: "",
    cheque_no: "",
    note: "",
    due_date: null,
    bank: "",
    cheque_layout: null
  }
  );

  const { confirmDelete } = useSwal();
  const { handleToast } = useToastHandler();
  const [invoices, setInvoices] = useState([]);
  const [editingInvoiceId, setEditingInvoiceId] = useState(null);
  const { Get, Post, Delete, Patch, Put, _Get, GetPaginatedData } = useApi();
  const [filteredExpenseTypes, setFilteredExpenseTypes] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [, setTotalCount] = useState(0);
  const [isLoadingData, setIsLoadingData] = useState(false);


 const chequePreviewData = {
  name: formData.vendor_department_name || "",
  amount: formData.amount || "0.00",
  date: formData.date || today,
  chequeNumber: formData.cheque_no || "",
  currency: currency, // ✅ ADD THIS
};


  // function calculateDaysDifference(startDate, endDate) {
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);
  //   const timeDiff = end - start;
  //   const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));
  //   return daysDiff;
  // }

  useEffect(() => {
    if (formData.date && formData.due_date) {

      const startDate = new Date(formData.date);
      const dueDate = new Date(formData.due_date);

      const timeDiff = dueDate - startDate;
      const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));

      setFormData((prevData) => ({
        ...prevData,
        days: daysDiff,
      }));
    }
  }, [formData.date, formData.due_date]);

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      prepaid_tax: checked,
    }));
  };
  const [reloadData, setReloadData] = useState(false);

  const getInvoiceData = async (page = 1, search = "") => {
    setIsLoadingData(true);
    try {
      const response = await GetPaginatedData("invoiceData", {
        page: page,
        search: search,
        queryParams: {
          type: "expense"
        }
      });

      const activeInvoices = response.data.filter((invoice) => !invoice.is_deleted);
      setInvoices(activeInvoices);

      setTotalPages(response.totalPages || Math.ceil(response.totalCount / 10) || 1);
      setTotalCount(response.totalCount || activeInvoices.length);
    } catch (error) {
      console.error("Error fetching invoices:", error);
      handleToast({
        type: "ERROR",
        message: "Error fetching invoices.",
      });
    } finally {
      setIsLoadingData(false);
    }
  };

  const handleSearch = (searchValue) => {
    setSearchTerm(searchValue);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    getInvoiceData(currentPage, searchTerm);
  }, [reloadData, currentPage, searchTerm]);

  const [loading, setLoading] = useState(false);
  const [reloadTotal, setReloadTotal] = useState(false);
  const getExpenseCalculation = async () => {
    setLoading(true);
    _Get("expenseCalculation")
      .then((response) => {
        setInvoicesExpense(response);
        setTotalPaid(response.total_paid);
        setTotalReceivedCredit(response.total_received_credit);
        setTotalUnpaid(response.total_unpaid);
        setTotalOutstandingCredit(response.total_outstanding_credit);
        setTotalDue(response.total_due);
        setTotalCredit(response.total_credit);
        setTotalExpense(response.total_purchase || 0);

      })
      .catch((error) => {
        console.error("Error fetching invoices:", error);
        handleToast({
          type: "ERROR",
          message: "Error fetching invoices.",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getExpenseCalculation();
  }, [reloadTotal]);

  const fetchData = async () => {
    try {
      const [vendorsResponse, serviceResponse, dueDaysResponse, bankResponse] =
        await Promise.all([
          GetPaginatedData("vendorDepartmentData"),
          GetPaginatedData("vendorDepartmentServiceData"),
          GetPaginatedData("dueDaysData"),
          GetPaginatedData("bank"),
        ]);
      setVendors(vendorsResponse.data || []);
      setServiceData(serviceResponse.data || []);
      setDueDays(dueDaysResponse.data || []);
      setBank(bankResponse.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      handleToast({
        type: "ERROR",
        message: "Error fetching data.",
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const updateVendors = (newVendor) => {
    setVendors(prev => [...prev, newVendor]);
  };

  const handleNewExpenseType = (newExpenseType) => {

    setServiceData((prevData) => [
      ...(Array.isArray(prevData) ? prevData : []),
      {
        id: newExpenseType.id,
        title: newExpenseType.title,
        type: "expense type",
      },
    ]);

    setFormData((prevData) => ({
      ...(prevData || {}),
      vendor_department_service_titles: "",
    }));

    setShowModalExpense(true);
  };

  useEffect(() => {
    const { pay_method_status } = formData;
    setShowPaymentOptions(pay_method_status === "pay_now");
    setShowAdditionalFields(
      pay_method_status === "credit_invoice" || pay_method_status === "pay_later"
    );
  }, [formData.pay_method_status]);

  const handlePaymentMethodChange = (e) => {
    const value = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      pay_method_status: value,
      pay_method:
        value === "pay_now"
          ? "cash"
          : value === "pay_later"
            ? "pay_later"
            : "credit_invoice",
      status: value === "pay_now" ? "paid" : "unpaid",
    }));

    setShowPaymentOptions(value === "pay_now");
    setShowAdditionalFields(
      value === "credit_invoice" || value === "pay_later"
    );
    setShowCheckFields(false);
    setShowBankFields(false);
  };

  const handleSpecificPaymentMethodChange = (e) => {
    const value = e.target.value;
    setShowCheckFields(value === "cheque");
    setShowBankFields(value === "bank");
    if (value !== "cheque") {
      setSelectedChequeLayout(null);
    }

    setFormData((prevData) => ({
      ...prevData,
      pay_method: value,
    }));
  };

  const toggleModal = () => {
    setShowModal(!showModal);
    if (showModal) {
      setFormData({
        type: "expense",
        invoice_no: "",
        date: today,
        status: "",
        pay_method_status: "pay_now",
        pay_method: "cash",
        amount: "",
        pay_amount: null,
        discount: null,
        remaining_amount: null,
        after_discount: null,
        prepaid_tax: false,
        prepaid_tax_percentage: "",
        vendor_department: "",
        vendor_department_name: "",
        cheque_no: "",
        note: "",
        due_date: "",
        bank: "",
      });
      setEditingInvoiceId(null);
    }
  };

  useEffect(() => {

    handlePaymentMethodChange({ target: { name: "pay_method_status", value: formData.pay_method_status } });
    handleSpecificPaymentMethodChange({ target: { name: "pay_method", value: formData.pay_method } });
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedData = {
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    };

    if (name === "vendor_department") {
      const selectedVendor = Array.isArray(vendors) ? vendors.find((vendor) => vendor.id === value) : null;
      updatedData.vendor_department_name = selectedVendor?.name || "";
      let vendorExpenseTypes = [];

      if (selectedVendor && Array.isArray(serviceData)) {

        if (selectedVendor.vendor_department_service && Array.isArray(selectedVendor.vendor_department_service)) {

          vendorExpenseTypes = serviceData.filter(service =>
            selectedVendor.vendor_department_service.includes(service.id) &&
            service.type === "expense type"
          );
        }

        else if (selectedVendor.vendor_department_service_title) {
          vendorExpenseTypes = serviceData.filter(service =>
            selectedVendor.vendor_department_service_title.includes(service.title) &&
            service.type === "expense type"
          );
        }

        else {
          vendorExpenseTypes = serviceData.filter(service => service.type === "expense type");
        }
      }
      setFilteredExpenseTypes(vendorExpenseTypes);
      updatedData.vendor_department_service_titles = vendorExpenseTypes.length > 0 ? vendorExpenseTypes[0].title : "";
    }

    if (name === "days") {
      const selectedDueDays = parseInt(value, 10);
      if (!isNaN(selectedDueDays)) {
        const today = new Date();
        const dueDate = new Date(today);
        dueDate.setDate(dueDate.getDate() + selectedDueDays);
        updatedData.due_date = dueDate.toISOString().split("T")[0];
      }
    }

    if (value === "add-expense") {
      setShowModalExpense(true);
    }
    setFormData(updatedData);
  };

  const handleOpenExpensePopUp = () => {
    setShowModalExpense(true);
  };

  const handleOpenVendorPopUp = () => {
    setShowModalVendor(true)
  }

  const handleEdit = (invoice) => {

    if (invoice.status === "partially_paid") {
      handleToast({
        type: "ERROR",
        message: "Cannot edit partially paid invoice.",
      });
      return;
    }

    const vendorId = invoice.vendor_department;
    const vendorDepartmentServiceTitles = invoice.vendor_department_service_titles || [];
    const selectedVendor = Array.isArray(vendors) ? vendors.find((vendor) => vendor.id === vendorId) : null;

    const updatedFormData = {
      ...invoice,
      type: "expense",
      vendor_department_name: selectedVendor?.name || "",
      vendor_department_service_titles: vendorDepartmentServiceTitles,
      due_date: invoice.due_date || "",
      amount: invoice.amount || "",
      remaining_amount: invoice.amount || ""
    };
    let vendorExpenseTypes = [];
    if (selectedVendor && Array.isArray(serviceData)) {
      if (selectedVendor.vendor_department_service && Array.isArray(selectedVendor.vendor_department_service)) {

        vendorExpenseTypes = serviceData.filter(service =>
          selectedVendor.vendor_department_service.includes(service.id) &&
          service.type === "expense type"
        );
      }
      else if (selectedVendor.vendor_department_service_title) {
        vendorExpenseTypes = serviceData.filter(service =>
          selectedVendor.vendor_department_service_title.includes(service.title) &&
          service.type === "expense type"
        );
      }

      else {
        vendorExpenseTypes = serviceData.filter(service => service.type === "expense type");
      }
    }
    setFilteredExpenseTypes(vendorExpenseTypes);
    setFormData(updatedFormData);
    if (invoice.pay_method === "cheque") {
      setShowCheckFields(true);

      GetPaginatedData("preferenceCompanyData").then((res) => {
        const matchedLayout = res.data.find(
          (l) => l.id === invoice.cheque_layout
        );
        setSelectedChequeLayout(matchedLayout || null);
      });
    } else {
      setSelectedChequeLayout(null);
    }

    setEditingInvoiceId(invoice.id);
    setShowModal(true);
  };

  const handleShow = () => setShowModalExpense(true);
  const handleCloseModal = () => {
    setShowModalExpense(false);
  };
  const handleShowVendor = () => setShowModalVendor(true);
  const handleCloseVendor = () => {
    setShowModalVendor(false);
  };
  const handleVendorAdded = (newVendor) => {
    setVendors((prevVendors) => [...prevVendors, newVendor]);
    setFormData({ ...formData, vendor_department: newVendor.id });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let updatedRemainingAmount = 0;
    if (formData.pay_method === "pay_later" && formData.pay_method_status === "pay_later") {
      updatedRemainingAmount = parseFloat(formData.amount) - parseFloat(formData.pay_amount || 0);
    } else {
      updatedRemainingAmount = 0;
    }

    formData.remaining_amount = updatedRemainingAmount >= 0 ? updatedRemainingAmount.toFixed(2) : "0.00";

    if (!editingInvoiceId) {
      const isDuplicateInvoiceNo = invoices.some(
        (invoice) => invoice.invoice_no === formData.invoice_no
      );
      if (isDuplicateInvoiceNo) {

        handleToast({
          type: "ERROR",
          message: "Invoice number must be unique!",
        });
        return;
      }
    }

    if (!formData.vendor_department) {

      handleToast({
        type: "ERROR",
        message: "Please Select a Vendor!",
      });
      return;
    }
    if (!formData.invoice_no) {

      handleToast({
        type: "ERROR",
        message: "Invoice number is required.!",
      });
      return;
    }
    if (!formData.vendor_department_service_titles) {

      handleToast({
        type: "ERROR",
        message: "Please select an expense type!",
      });
      return;
    }
    if (formData.pay_method_status === "pay_later") {
      if (!formData.pay_method) {

        handleToast({
          type: "ERROR",
          message: "Please select a payment method!",
        });
        return;
      }

      if (!formData.due_date) {

        handleToast({
          type: "ERROR",
          message: "Please select a Due Date!",
        });
        return;
      }
      if (!formData.amount) {

        handleToast({
          type: "ERROR",
          message: "Please fill in the Amount!",
        });
        return;
      }
    }
    formData.due_date = null;
    if (formData.pay_method_status === "pay_now") {
      if (!formData.pay_method) {

        handleToast({
          type: "ERROR",
          message: "Please select a payment method.!",
        });
        return;
      }

      if (formData.pay_method === "cash" && !formData.amount) {

        handleToast({
          type: "ERROR",
          message: "Please fill in the Amount!",
        });
        return;
      }

      if (formData.pay_method === "bank") {
        if (!formData.bank) {

          handleToast({
            type: "ERROR",
            message: "Please select a Bank!",
          });
          return;
        }
        if (!formData.amount) {

          handleToast({
            type: "ERROR",
            message: "Please fill in the Amount!",
          });
          return;
        }
      }

      if (formData.pay_method === "cheque") {
        if (!formData.bank) {

          handleToast({
            type: "ERROR",
            message: "Please select a Bank!",
          });
          return;
        }

        if (!formData.cheque_no) {

          handleToast({
            type: "ERROR",
            message: "Please fill in the Cheque No!",
          });
          return;
        }
        if (!formData.amount) {

          handleToast({
            type: "ERROR",
            message: "Please fill in the Amount",
          });
          return;
        }
      }
    }

    const updatedFormData = {
      ...formData,
      amount: formData.amount,

    };

    if (formData.pay_method_status === "pay_now") {
      updatedFormData.status = "paid";
      updatedFormData.due_date = null;
    }

    try {
      let response;
      if (editingInvoiceId) {
        const originalInvoice = invoices.find((invoice) => invoice.id === editingInvoiceId);
        if (!originalInvoice) {
          console.error("Invoice not found for editingInvoiceId:", editingInvoiceId);
          handleToast({
            type: "ERROR",
            message: "Invoice not found for editingInvoiceId",
          });
          return;
        }

        updatedFormData.pay_amount = formData.pay_amount !== undefined
          ? formData.pay_amount
          : formData.remaining_amount;

        if (formData.pay_method_status === "pay_now") {
          updatedFormData.status = "paid";
        }
        if (formData.pay_method_status === "pay_later") {
          updatedFormData.status = "unpaid";
        }

        const updatedInvoice = {
          ...updatedFormData,
          cheque_layout:
            formData.pay_method === "cheque"
              ? selectedChequeLayout?.id || null
              : null,

          invoice_id: editingInvoiceId,
        };

        response = await Post("editInvoice", updatedInvoice);

        if (response.status === 200) {
          setInvoices((prevInvoices) =>
            prevInvoices.map((invoice) =>
              invoice.id === editingInvoiceId ? { ...invoice, ...updatedInvoice } : invoice
            )
          );

          handleToast({
            type: "SUCCESS",
            message: "Invoice updated successfully!",
          });
          setReloadData(!reloadData);
          setReloadTotal(!reloadTotal);
          toggleModal();
        }
      } else {
        const duplicateInvoice = invoices.some(
          (invoice) => invoice.invoice_no === formData.invoice_no
        );
        if (duplicateInvoice) {

          handleToast({
            type: "ERROR",
            message: "Invoice number must be unique.",
          });
          return;
        }

        const newInvoiceData = {
          ...updatedFormData,
          cheque_layout:
            formData.pay_method === "cheque"
              ? selectedChequeLayout?.id || null
              : null,
          remaining_amount: formData.pay_method_status === "pay_now" ? "0.00" : formData.amount,
          status: formData.pay_method_status === "pay_now" ? "paid" : "unpaid"
        };

        response = await Post("createInvoiceAndPrepaidTax", newInvoiceData);
        if (response.status === 200 || response.status === 201) {

          handleToast({
            type: "SUCCESS",
            message: "Invoice submitted successfully!",
          });
          setReloadData(!reloadData);
          setReloadTotal(!reloadTotal);
          toggleModal();
        }
      }
    } catch (error) {
      console.error("Error submitting invoice:", error);
      handleToast({
        type: "ERROR",
        message: "Error submitting invoice: " +
          (error.response ? error.response.data : error.message)
      });

    }
  };

  const handleDelete = async (id) => {
    const result = await confirmDelete();
    if (!result.isConfirmed) return;
    try {

      const payload = {
        invoice_id: id,
        is_deleted: true,
      };

      const response = await Post(`deleteInvoice`, payload);

      handleToast({
        type: "SUCCESS",
        message: "Invoice deleted successfully!",
      });

      setReloadData(!reloadData);
      await getExpenseCalculation();
    } catch (error) {
      console.error("Error deleting invoice:", error);

      handleToast({
        type: "ERROR",
        message: "Error deleting invoice: " +
          (error.response ? error.response.data : error.message)
      });
    }
  };

  const expenseInvoice = invoices.filter(
    (invoice) => invoice.type === "expense" && !invoice.is_deleted
  );
  const formattedExpenseInvoices = expenseInvoice.map(item => ({
    ...item,
    date: item.date ? formatDate(item.date) : "N/A",
    due_date: item.due_date ? formatDate(item.due_date) : "-"
  }));
  const columns = [
    { header: "Date", field: "date" },
    { header: "Invoice Number", field: "invoice_no" },
    { header: "Vendor Name", field: "vendor_department_name" },
    { header: "Expense Type", field: "vendor_department_service_titles" },

    { header: "Due Date", field: "due_date" },
    { header: "Amount", field: "amount" },
    { header: "Remaining Amount", field: "remaining_amount" },
    { header: "Payment Method", field: "pay_method" },
    { header: "Status", field: "status" },
  ];

  return (
    <div>
      <div className="responsive-box">
        <div className="">
          <div
            className="d-flex align-items-center mb-3"
            style={{
              justifyContent: "space-between",
              gap: "10px",
              marginBottom: "10px",
            }}
          >
            { }
            <h3 className="mb-1" style={{ margin: "0" }}>Expense</h3>

            { }
            <div className="d-flex align-items-center" style={{ gap: "10px" }}>

              <button
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#4A5546",
                  boxShadow: "none",
                  outline: "none",
                  width: "auto",
                  height: "42px",
                  padding: "8px 12px",
                  fontSize: "14px",
                  border: "none",
                  borderRadius: "10px",
                  color: "#F4FFEE",
                  cursor: "pointer",
                  fontWeight: 'bold',
                  gap: "8px",

                }}
                onClick={handleOpenExpensePopUp}
                id="expensetypeaddbtn"
              >
                Add Expense Type
                <img
                  src={expensetype}
                  alt="Expense Type Icon"
                  style={{ width: "20px", height: "20px" }}
                />
              </button>

              <button
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#4A5546",
                  boxShadow: "none",
                  outline: "none",
                  width: "auto",
                  height: "42px",
                  padding: "8px 12px",
                  fontSize: "14px",
                  border: "none",
                  borderRadius: "10px",
                  color: "#F4FFEE",
                  cursor: "pointer",
                  fontWeight: 'bold',
                  gap: "8px",
                }}
                onClick={handleOpenVendorPopUp}
                id="expenseVendorAddBtn"
              >
                Add New Vendor
                <img
                  src={vendor}
                  alt="Vendor Icon"
                  style={{ width: "20px", height: "20px" }}
                />
              </button>

              <Can module="invoiceService" action="add">
              <button
                id="addexpenseinvoicebtn"
                onClick={() => navigate("/expense-invoice")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#FFAF32",
                  boxShadow: "none",
                  outline: "none",
                  width: "auto",
                  height: "42px",
                  padding: "8px 12px",
                  fontSize: "14px",
                  border: "none",
                  borderRadius: "10px",
                  color: "#000",
                  cursor: "pointer",
                  fontWeight: 'bold',
                  gap: "8px",
                }}
              >
                Add Expense Invoice
                <img
                  src={invoiceIcon}
                  alt="Invoice Icon"
                  style={{ width: "20px", height: "20px" }}
                />
              </button>
              </Can>
            </div>
          </div>

          <div className="table-responsive">

            <ToastContainer />
            <DataTable
              data={formattedExpenseInvoices}
              columns={columns}
              showAction={true}
              showFooter={true}
              onEdit={handleEdit}
              onDelete={handleDelete}
              canEdit={can("invoiceService", "change")}
              canDelete={can("invoiceService", "delete")}
              totals={{
                totalPaid,
                totalReceivedCredit,
                totalUnpaid,
                totalOutstandingCredit,
                totalDue,
                totalCredit,
                totalExpense,
              }}
              loading={loading || isLoadingData}

              enableServerSideSearch={true}
              onSearch={handleSearch}
              onPageChange={handlePageChange}
              currentPage={currentPage}
              totalPages={totalPages}
              searchTerm={searchTerm}
            />
          </div>

          {showModal && (
            <div className="modal-overlay" onClick={toggleModal}

            >
              <div
                className="modal-container"
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: "1200px",
                  backgroundColor: "white",
                  margin: "100px auto",

                  borderRadius: "40px",
                  position: "relative",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                <div className="modal-header" style={{ border: "none" }}>
                  <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                    {editingInvoiceId ? "Edit Expense" : "Add New Expense"}
                  </h5>
                  <img
                    src={CloseIcon}
                    alt="Close"
                    width="34"
                    height="34"
                    onClick={toggleModal}
                  />
                  { }
                </div>
                <div className="modal-body"
                  style={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                  }}>
                  <form>
                    <div className="form-row form-group col-md-12 position-relative d-flex" style={{ gap: "30px", marginLeft: "10px" }}>
                      <div className="col-md-3 " style={{ paddingRight: "10px" }}>
                        <input
                          style={{
                            backgroundColor: "#ffffff",
                            border: "none",
                            borderBottom: "1px solid #ccc",
                            borderRadius: "0px",
                            height: "52px",

                          }}
                          type="date"
                          className="form-control-borderless "
                          id="billDate"
                          name="date"
                          value={formData.date || today}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-3" style={{ paddingRight: "10px" }}>
                        <input
                          style={{
                            backgroundColor: "#ffffff",
                            border: "none",
                            borderBottom: "1px solid #ccc",
                            borderRadius: "0px",
                            height: "52px",
                            outline: "none",

                          }}
                          type="text"
                          className="form-control-borderless "
                          name="invoice_no"
                          placeholder="Invoice Number"
                          value={formData.invoice_no}
                          onChange={handleChange}
                          required
                        />

                      </div>
                      <div className="col-md-5" style={{ paddingRight: "10px" }}>
                        <select
                          style={{
                            backgroundColor: "#ffffff",
                            border: "none",
                            borderBottom: "1px solid #ccc",
                            borderRadius: "0px",
                            height: "52px",
                          }}
                          className="input-select "
                          name="vendor_department"
                          value={formData.vendor_department}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            if (selectedValue === "add-vendor") {
                              handleShowVendor();
                              setFormData((prevData) => ({
                                ...prevData,
                                vendor_department: "",
                              }));
                            } else {
                              handleChange(e);
                            }
                          }}
                        >
                          <option value="">Select Vendor</option>
                          <option value="add-vendor">Add Vendor</option>
                          {vendors
                            .filter((vendor) => vendor.type === "expense" && !vendor.is_deleted)
                            .map((vendor) => (
                              <option key={vendor.id} value={vendor.id}>
                                {vendor.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-center col-md-12  " style={{ gap: "30px", marginLeft: "5px" }}>

                      <div className="col-md-3" style={{ paddingRight: "10px" }}>
                        <select
                          className="input-select"
                          style={{
                            backgroundColor: "#ffffff",
                            border: "none",
                            borderBottom: "1px solid #ccc",
                            borderRadius: "0px",
                            height: "52px",
                          }}
                          name="vendor_department_service_titles"
                          value={formData.vendor_department_service_titles}
                          onChange={handleChange}
                          id="expenseType"
                          required
                        >
                          <option value="">Expense Type</option>
                          <option value="add-expense">Add Expense Type</option>
                          {filteredExpenseTypes.map((service) => (
                            <option key={service.id} value={service.title}>
                              {service.title}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div
                        className="form-row d-flex col-md-3"
                        style={{
                          backgroundColor: "#ffffff",
                          border: "none",

                          borderRadius: "0px",
                          height: "52px",
                        }}
                      >
                        <div className="input-group col-md-6">
                          <div
                            className="input-group-prepend"
                            style={{
                              backgroundColor: "#ffffff",
                              height: "100%",

                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            { }
                          </div>
                          <input
                            className="form-control-borderless "
                            placeholder="Amount"
                            aria-label="Amount"
                            aria-describedby="addon-wrapping"
                            name={editingInvoiceId ? "amount" : "amount"}
                            value={
                              editingInvoiceId && formData.pay_amount === undefined
                                ? formData.remaining_amount
                                : formData.amount || formData.amount
                            }
                            onInput={(e) => {

                              e.target.value = e.target.value
                                .replace(/[^0-9.]/g, '')
                                .replace(/^(\d*\.?\d{0,2}).*/g, '$1')
                                .slice(0, 12);
                            }}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          border: '1px solid #ACB4AA',
                          padding: '10px 8px',
                          width: 'fit-content',
                          borderRadius: '40px',
                          marginTop: '10px',
                          display: 'flex',
                          gap: '10px',
                        }}
                      >

                        <label
                          className="radio-inline"

                        >
                          <input
                            type="radio"
                            name="pay_method_status"
                            value="pay_now"
                            checked={formData.pay_method_status === 'pay_now'}
                            onChange={handlePaymentMethodChange}
                            style={{ display: 'none' }}
                            disabled={!!editingInvoiceId}
                          />
                          <span
                            style={{
                              backgroundColor: formData.pay_method_status === 'pay_now' ? '#4a5546' : 'transparent',
                              color: formData.pay_method_status === 'pay_now' ? '#fff' : '#000',
                              padding: '8px 15px',
                              borderRadius: '20px',
                              cursor: editingInvoiceId ? 'not-allowed' : 'pointer',
                            }}
                          >
                            Pay Now
                          </span>
                        </label>

                        <label
                          className="radio-inline"

                        >
                          <input
                            type="radio"
                            name="pay_method_status"
                            value="pay_later"
                            checked={formData.pay_method_status === 'pay_later'}
                            onChange={handlePaymentMethodChange}
                            style={{ display: 'none' }}
                            disabled={!!editingInvoiceId}
                          />
                          <span
                            style={{
                              backgroundColor: formData.pay_method_status === 'pay_later' ? '#4a5546' : 'transparent',
                              color: formData.pay_method_status === 'pay_later' ? '#fff' : '#000',
                              padding: '8px 15px',
                              borderRadius: '20px',
                              cursor: editingInvoiceId ? 'not-allowed' : 'pointer',
                            }}
                          >
                            Pay Later
                          </span>
                        </label>

                        <label
                          className="radio-inline"

                        >
                          <input
                            type="radio"
                            name="pay_method_status"
                            value="credit_invoice"
                            checked={formData.pay_method_status === 'credit_invoice'}
                            onChange={handlePaymentMethodChange}
                            style={{ display: 'none' }}
                            disabled={!!editingInvoiceId}
                          />
                          <span
                            style={{
                              backgroundColor: formData.pay_method_status === 'credit_invoice' ? '#4a5546' : 'transparent',
                              color: formData.pay_method_status === 'credit_invoice' ? '#fff' : '#000',
                              padding: '8px 15px',
                              borderRadius: '20px',
                              cursor: editingInvoiceId ? 'not-allowed' : 'pointer',
                            }}
                          >
                            Credit Invoice
                          </span>
                        </label>
                      </div>
                    </div>

                    {showPaymentOptions && (
                      <div
                        className="d-flex col-md-6 mb-3"
                        style={{
                          border: "1px solid #ACB4AA",
                          padding: "5px 7px",
                          width: "fit-content",
                          borderRadius: "40px",
                          display: "flex",
                          gap: "10px",
                          marginTop: "20px",
                          marginLeft: "12px",
                        }}
                      >
                        {[
                          { value: "cash", label: "Cash" },
                          { value: "bank", label: "Bank Card/ACH/EFT" },
                          { value: "cheque", label: "Check" },
                        ].map((method) => (
                          <label
                            key={method.value}
                            className="radio-inline"
                            style={{
                              backgroundColor: formData.pay_method === method.value ? "#4a5546" : "transparent",
                              color: formData.pay_method === method.value ? "white" : "black",
                              padding: "5px 10px",
                              borderRadius: "20px",
                              cursor: "pointer",
                            }}
                          >
                            <input
                              type="radio"
                              name="specificPaymentMethod"
                              value={method.value}
                              checked={formData.pay_method === method.value}
                              onChange={handleSpecificPaymentMethodChange}
                              style={{ display: "none" }}
                            />
                            {method.label}
                          </label>
                        ))}
                      </div>

                    )}

                    {(formData.pay_method_status === "pay_later" ||
                      formData.pay_method_status === "credit_invoice") && (
                        <div className="col-md-6 d-flex" style={{ paddingRight: "10px", marginTop: '20px', marginLeft: "10px" }}>
                          <select
                            className="form-control-borderless col-md-6"
                            name="days"
                            value={formData.days || ""}
                            onChange={handleChange}
                            style={{
                              backgroundColor: "#fff",

                              border: "none",
                              borderBottom: "1px solid #ccc",
                              borderRadius: "0px",
                              height: "52px",
                            }}
                            required
                          >
                            <option value="">Select Due Days</option>
                            {dueDays.map((day) => (
                              <option key={day.id} value={day.days}>
                                {day.days}
                              </option>
                            ))}
                          </select>

                          { }
                        </div>
                      )}

                    {/* {showCheckFields && (
                      <div className="d-flex col-md-12 mb-3 ">
                        <div className="d-flex col-md-4 mt-2" style={{ marginLeft: "10px" }}>
                          <select
                            style={{
                              backgroundColor: "#fff",

                              border: "none",
                              borderBottom: "1px solid #ccc",
                              borderRadius: "0px",
                              height: "52px",
                              marginRight: "10px",

                            }}
                            className="input-select"
                            name="bank"
                            value={formData.bank}
                            onChange={handleChange}
                          >
                            <option value="">Select Bank</option>
                            {bank.map((bank) => (
                              <option key={bank.id} value={bank.id}>
                                {bank.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="d-flex col-md-4 mt-2">
                          <input
                            type="text"
                            className="form-control-borderless  me-2"
                            placeholder="Check Number"
                            style={{
                              backgroundColor: "#fff",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              borderRadius: "0px",
                              height: "52px",
                              marginRight: "10px",
                            }}
                            id="checkNumber"
                            name="cheque_no"
                            value={formData.cheque_no}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        { }
                      </div>
                    )} */}


                    {showCheckFields && (
                      <>
                        <div className="d-flex col-md-10 mb-3">
                          <div
                            className="d-flex col-md-4 mt-2"
                            style={{ marginLeft: "20px" }}
                          >
                            <select
                              style={{
                                backgroundColor: "#fff",
                                border: "none",
                                borderBottom: "1px solid #ccc",
                                borderRadius: "0px",
                                height: "52px",
                                marginRight: "10px",
                              }}
                              className="input-select"
                              name="bank"
                              value={formData.bank}
                              onChange={handleChange}
                            >
                              <option value="">Select Bank</option>
                              {bank.map((bank) => (
                                <option key={bank.id} value={bank.id}>
                                  {bank.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="d-flex col-md-4 mt-2">
                            <input
                              type="text"
                              className="form-control-borderless  me-2"
                              placeholder="Check Number"
                              style={{
                                backgroundColor: "#fff",
                                border: "none",
                                borderBottom: "1px solid #ccc",
                                borderRadius: "0px",
                                height: "52px",
                                marginRight: "10px",
                              }}
                              id="checkNumber"
                              name="cheque_no"
                              value={formData.cheque_no}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^\d{0,15}$/.test(val)) {
                                  handleChange(e);
                                }
                              }}
                              required
                            />
                          </div>
                          <div className="d-flex col-md-4 mt-2">
                            <div style={{ width: "100%", marginTop: '20px' }}>
                              {/* <label className="form-label">Cheque Layout *</label> */}
                              <PaginatedSearchSelect
                                api="preferenceCompanyData"
                                GetPaginatedData={GetPaginatedData}
                                placeholder="Select Cheque Layout"
                                value={selectedChequeLayout}
                                getOptionLabel={(opt) => opt.layout_name}
                                onSelect={(opt) => setSelectedChequeLayout(opt)}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-row d-flex col-md-12 mt-4" style={{ marginLeft: "20px" }}>
                          <label>
                            Do you want to add prepaid tax? &nbsp;
                            <input
                              type="checkbox"
                              id="prepaidTax"
                              onChange={handleCheckboxChange}
                              checked={formData.prepaid_tax}
                              name="prepaid_tax"
                            />
                          </label>

                        </div>

                        {formData.prepaid_tax && (
                          <div className="form-row d-flex col-md-3 p-2 mt-2" style={{
                            backgroundColor: "#fff",
                            border: "none",

                            borderRadius: "0px",
                            height: "52px",
                            marginLeft: "5px"
                          }}>
                            <div className="input-group col-md-6">
                              {/* <div
                            className="input-group-prepend"
                            style={{
                              background: "#F5F5F5",
                              height: "100%",
                              borderRadius: "10px 0 0 10px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            { }
                          </div> */}
                              <input
                                type="text"
                                className="form-control-borderless"
                                placeholder="Amount"
                                aria-label="Prepaid Tax"
                                name="prepaid_amount"
                                value={formData.prepaid_amount || ""}
                                onChange={handleChange}
                                onInput={(e) => {

                                  e.target.value = e.target.value
                                    .replace(/[^0-9.]/g, '')
                                    .replace(/^(\d*\.?\d{0,2}).*/g, '$1')
                                    .slice(0, 12);
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {/* Cheque Preview */}
                        {selectedChequeLayout && (
                          <div className="row mt-4 mx-3">
                            <div className="col-12">
                              <h6 style={{ marginBottom: "10px" }}>Cheque Preview</h6>
                              <div
                                style={{
                                  background: "#f8f9fa",
                                  padding: "10px",
                                  borderRadius: "8px",
                                  overflow: "auto",
                                  minHeight: "260px",

                                }}
                              >
                                <ChequeRenderer
                                  layout={selectedChequeLayout}
                                  chequeData={chequePreviewData}
                                  
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {showBankFields && (
                      <div className="d-flex col-md-12" style={{ marginLeft: "10px", marginTop: '20px', }}>
                        <div className="d-flex col-md-3">
                          <select
                            style={{
                              backgroundColor: "#fff",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              borderRadius: "0px",
                              height: "52px",
                              marginRight: "10px",
                            }}
                            className="input-select"
                            name="bank"
                            value={formData.bank}
                            onChange={handleChange}
                          >
                            <option value="">Select Bank</option>
                            {bank.map((bank) => (
                              <option key={bank.id} value={bank.id}>
                                {bank.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="d-flex col-md-6 mt-2">
                          { }
                        </div>
                      </div>
                    )}



                  </form>

                </div>
                <div className="modal-footer" style={{ border: "none", gap: '2%' }}>
                  <button
                    type="button"
                    className="btn btn-secondary-outline"
                    onClick={toggleModal}
                    style={{
                      border: " 1px solid #282e26", borderRadius: '50px', width: "181px",
                      height: "45px", fontWeight: "bold"
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    style={{
                      color: "white", backgroundColor: '#282e26', borderRadius: '50px', width: "181px",
                      height: "45px", fontWeight: "bold"
                    }}
                    className="btn"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <AddVendorModal
        show={showModalVendor}
        handleClose={handleCloseVendor}
        onVendorAdded={handleVendorAdded}
        updateVendors={updateVendors}

      />
      <AddExpenseTypeModal
        show={showModalExpense}
        handleClose={handleCloseModal}
        onExpenseTypeAdded={handleNewExpenseType}
      />
    </div>
  );
}